import ProductHelper from './../helpers/product-helper.js'
class LineItem {
  constructor() {
  }

  getTotal() {
    return this.quantity ? this.quantity * this.unitPrice : this.unitPrice;
  }

  /*
    will return total divided by 100
  */
  getAmount() {
    return (this.getTotal() / 100);
  }

  displayTotal() {
    return this.currencySymbol + this.getAmount().toFixed(2);
  }

  isAddon() {
    return this.type == "addon";
  }

  static constructItems(checkout) {
    this.addPlan(checkout);
    this.addAddons(checkout)
  }

  static addPlan(checkout) {
    let lineItem = new LineItem();
    let helper = new ProductHelper(checkout.product);
    let planDetails = helper.fetchPlanBasedOnId(checkout.cart.plan);
    lineItem['id'] = checkout.cart.plan;
    lineItem['name'] = planDetails.name;
    lineItem['description'] = planDetails.description;
    lineItem['type'] = "plan";
    lineItem['quantity'] = checkout.cart.planQuantity && Number.parseInt(checkout.cart.planQuantity);
    lineItem['unitPrice'] = planDetails.price && Number.parseFloat(planDetails.price);

    // TODO where to set currency type
    lineItem['currencySymbol'] = planDetails.currency_symbol;
    checkout.lineItems.push(lineItem);
  }

  static addAddons(checkout) {
    checkout.cart.addons.forEach((addon) => {
      let lineItem = new LineItem();
      let helper = new ProductHelper(checkout.product);
      let addonDetails = helper.fetchAddonBasedOnId(addon.id);
      lineItem['id'] = addon.id;
      lineItem['name'] = addonDetails.name;
      lineItem['description'] = addonDetails.description;
      lineItem['type'] = "addon";
      lineItem['quantity'] = addon.quantity && Number.parseInt(addon.quantity);
      lineItem['unitPrice'] = addonDetails.price && Number.parseFloat(addonDetails.price);

      // TODO where to set currency type
      lineItem['currencySymbol'] = addonDetails.currency_symbol;
      checkout.lineItems.push(lineItem);
    });
  }
}

export default LineItem;


// WEBPACK FOOTER //
// ./src/models/line-item.js